import styled, { css } from 'styled-components';
import Typography from '@anwb/typography';
/**
 * Legend Container
 *
 * The legend needs a reset, this is done by adding float: left, otherwise the legend will have some negative margin-top
 * that cannot be overridden. As a result of the float, the float needs te be cleared.
 */
export const legendContainerStyles = () => css `
	float: left;
	width: 100%;

	+ * {
		clear: both;
	}
`;
export const LegendContainer = styled(Typography).attrs({
    tagName: 'legend',
    variant: 'component-title',
}) `
	${legendContainerStyles}
`;
//# sourceMappingURL=legend.styled.js.map